document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.add('js-ready');

  // ---- Hero banner slideshow ----
  document.querySelectorAll('.hero-banner').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero-banner__slide');
    if (!slides.length) return;
    var current = 0;
    var counter = hero.querySelector('.hero-banner__counter .current');
    var autoplay = hero.dataset.autoplay === 'true';
    var interval = parseInt(hero.dataset.interval, 10) || 5000;
    var timer;

    function show(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (counter) counter.textContent = current + 1;
    }

    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function start() {
      if (!autoplay || slides.length < 2) return;
      timer = setInterval(next, interval);
    }
    function stop() { clearInterval(timer); }

    var nextBtn = hero.querySelector('.hero-banner__next');
    var prevBtn = hero.querySelector('.hero-banner__prev');
    var pauseBtn = hero.querySelector('.hero-banner__pause');
    var paused = false;

    if (nextBtn) nextBtn.addEventListener('click', function () { stop(); next(); if (!paused) start(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { stop(); prev(); if (!paused) start(); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused;
      if (paused) { stop(); pauseBtn.innerHTML = '&#9654;'; }
      else { start(); pauseBtn.innerHTML = '&#10074;&#10074;'; }
    });

    start();
  });

  // ---- Lightweight wishlist feedback (visual only; no customer-account persistence) ----
  document.querySelectorAll('.product-card__wishlist').forEach(function (button) {
    button.addEventListener('click', function () {
      var active = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  });

  // ---- Compare product selects ----
  document.querySelectorAll('.compare-products__select').forEach(function (select) {
    select.addEventListener('change', function () {
      // Hook point for loading product comparison data.
    });
  });

  // ---- Scroll-reveal animation ----
  var targets = document.querySelectorAll('[data-animate]');
  if (targets.length) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      targets.forEach(function (el) { observer.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  // ---- Animated stat counters (count up from 0 when scrolled into view) ----
  var statEls = document.querySelectorAll('.stat__value[data-count-to]');
  if (statEls.length) {
    var parseCountValue = function (raw) {
      var match = (raw || '').trim().match(/^(\D*)([\d]*\.?[\d]+)(.*)$/);
      if (!match) return null;
      var numStr = match[2];
      return {
        prefix: match[1],
        suffix: match[3],
        decimals: (numStr.split('.')[1] || '').length,
        target: parseFloat(numStr)
      };
    };

    var setZeroState = function (el, parsed) {
      el.textContent = parsed.prefix + (0).toFixed(parsed.decimals) + parsed.suffix;
    };

    var animateCount = function (el) {
      var parsed = parseCountValue(el.getAttribute('data-count-to'));
      if (!parsed || isNaN(parsed.target)) return;
      var duration = 1400;
      var startTime = null;

      var frame = function (ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = parsed.prefix + (parsed.target * eased).toFixed(parsed.decimals) + parsed.suffix;
        if (progress < 1) {
          requestAnimationFrame(frame);
        } else {
          el.textContent = parsed.prefix + parsed.target.toFixed(parsed.decimals) + parsed.suffix;
        }
      };
      requestAnimationFrame(frame);
    };

    statEls.forEach(function (el) {
      var parsed = parseCountValue(el.getAttribute('data-count-to'));
      if (parsed && !isNaN(parsed.target)) setZeroState(el, parsed);
    });

    if ('IntersectionObserver' in window) {
      var statObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            statObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4, rootMargin: '0px 0px -40px 0px' });
      statEls.forEach(function (el) { statObserver.observe(el); });
    } else {
      statEls.forEach(function (el) { el.textContent = el.getAttribute('data-count-to'); });
    }
  }

  // ---- Header icon panels: tap-to-toggle (hover alone isn't reliable on touch) ----
  var headerGroups = document.querySelectorAll('.header-icon-group');
  if (headerGroups.length) {
    headerGroups.forEach(function (group) {
      var trigger = group.querySelector('.site-header__icon-btn');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        var willOpen = !group.classList.contains('is-open');
        headerGroups.forEach(function (other) { other.classList.remove('is-open'); });
        if (willOpen) {
          group.classList.add('is-open');
          e.stopPropagation();
        }
      });
    });
    document.addEventListener('click', function (e) {
      headerGroups.forEach(function (group) {
        if (!group.contains(e.target)) group.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        headerGroups.forEach(function (group) { group.classList.remove('is-open'); });
      }
    });
  }

  // ---- Sticky header shadow on scroll ----
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- Cart page: quantity steppers + remove line ----
  var cartForm = document.querySelector('.cart-form');
  if (cartForm) {
    cartForm.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('.qty-stepper__input');
      var decrease = stepper.querySelector('[data-qty-decrease]');
      var increase = stepper.querySelector('[data-qty-increase]');
      if (!input) return;

      function setValue(value) {
        var next = Math.max(0, value);
        input.value = next;
        cartForm.submit();
      }

      if (decrease) {
        decrease.addEventListener('click', function () {
          setValue((parseInt(input.value, 10) || 0) - 1);
        });
      }
      if (increase) {
        increase.addEventListener('click', function () {
          setValue((parseInt(input.value, 10) || 0) + 1);
        });
      }
    });

    cartForm.querySelectorAll('[data-cart-remove]').forEach(function (removeBtn) {
      removeBtn.addEventListener('click', function () {
        var row = removeBtn.closest('.cart-item');
        var input = row && row.querySelector('.qty-stepper__input');
        if (input) {
          input.value = 0;
          cartForm.submit();
        }
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // ---- Product tabs: filter by category ----
  document.querySelectorAll('.product-tabs').forEach(function (section) {
    var tabs = section.querySelectorAll('.product-tabs__tab');
    var items = section.querySelectorAll('.product-tabs__item');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var filter = tab.dataset.filter;
        items.forEach(function (item) {
          var cats = (item.dataset.category || '').split(',').map(function (c) { return c.trim(); });
          var show = filter === 'all' || cats.indexOf(filter) !== -1;
          item.hidden = !show;
        });
      });
    });
  });

  // ---- Split testimonial slider ----
  document.querySelectorAll('.split-testimonial').forEach(function (section) {
    var slides = section.querySelectorAll('.split-testimonial__slide');
    var dots = section.querySelectorAll('.split-testimonial__dot');
    var prev = section.querySelector('.split-testimonial__prev');
    var next = section.querySelector('.split-testimonial__next');
    if (slides.length < 2) return;
    var current = 0;
    function show(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }
    if (next) next.addEventListener('click', function () { show(current + 1); });
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); }); dot.style.cursor = 'pointer'; });
  });

  // ---- Tabbed banner ----
  document.querySelectorAll('.tabbed-banner').forEach(function (section) {
    var buttons = section.querySelectorAll('.tabbed-banner__tabbtn');
    var panels = section.querySelectorAll('.tabbed-banner__panel');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var idx = btn.dataset.tabIndex;
        var panel = section.querySelector('.tabbed-banner__panel[data-tab-panel="' + idx + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  // ---- Bundle builder: select cards + running total ----
  document.querySelectorAll('.bundle-builder').forEach(function (section) {
    var cards = section.querySelectorAll('.bundle-builder__card');
    var countEl = section.querySelector('[data-bundle-count]');
    var totalEl = section.querySelector('[data-bundle-total]');
    function recalc() {
      var count = 0, total = 0;
      cards.forEach(function (card) {
        if (card.classList.contains('is-selected')) {
          count++;
          total += parseFloat(card.dataset.price) || 0;
        }
      });
      if (countEl) countEl.textContent = count;
      if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        card.classList.toggle('is-selected');
        recalc();
      });
    });
    recalc();
  });

  // ---- Countdown banner ----
  document.querySelectorAll('[data-countdown]').forEach(function (timer) {
    var target = new Date(timer.getAttribute('data-countdown').replace(' ', 'T'));
    if (isNaN(target.getTime())) return;
    var daysEl = timer.querySelector('[data-cd-days]');
    var hoursEl = timer.querySelector('[data-cd-hours]');
    var minsEl = timer.querySelector('[data-cd-mins]');
    var secsEl = timer.querySelector('[data-cd-secs]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff < 0) diff = 0;
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }
    tick();
    setInterval(tick, 1000);
  });

  // ---- Category carousel: arrow scroll ----
  document.querySelectorAll('.category-carousel').forEach(function (section) {
    var track = section.querySelector('.category-carousel__track');
    var prev = section.querySelector('.category-carousel__prev');
    var next = section.querySelector('.category-carousel__next');
    if (!track) return;
    function scrollAmount() { return track.clientWidth * 0.7; }
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
  });

  // ---- Hotspot image: toggle callouts ----
  document.querySelectorAll('.hotspot-image__dot').forEach(function (dot) {
    dot.addEventListener('click', function (e) {
      var willOpen = !dot.classList.contains('is-open');
      document.querySelectorAll('.hotspot-image__dot').forEach(function (d) { d.classList.remove('is-open'); });
      if (willOpen) { dot.classList.add('is-open'); e.stopPropagation(); }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hotspot-image__dot')) {
      document.querySelectorAll('.hotspot-image__dot').forEach(function (d) { d.classList.remove('is-open'); });
    }
  });
});


document.addEventListener('DOMContentLoaded',function(){
  var cart=[], drawer=document.querySelector('[data-fu-demo-cart]'), items=document.querySelector('[data-fu-demo-cart-items]'), total=document.querySelector('[data-fu-demo-cart-total]'), counts=document.querySelectorAll('[data-fu-demo-count]'), toast=document.querySelector('[data-fu-demo-toast]');
  var demoMenuToggle=document.querySelector('[data-fu-menu-toggle]'), demoMenuPanel=document.querySelector('[data-fu-menu-panel]');
  if(demoMenuToggle&&demoMenuPanel){demoMenuToggle.addEventListener('click',function(e){e.preventDefault();demoMenuPanel.hidden=!demoMenuPanel.hidden},true)}
  function money(v){return '$'+Number(v).toFixed(2)}
  function showToast(msg){if(!toast)return;toast.textContent=msg;toast.hidden=false;clearTimeout(toast._t);toast._t=setTimeout(function(){toast.hidden=true},1500)}
  function render(){var sum=0;counts.forEach(function(c){c.textContent=cart.length;c.style.display=cart.length?'flex':'none'});if(!items)return;if(!cart.length){items.innerHTML='<div class="fu-demo-cart__empty"><strong>Your cart is empty</strong><p>Add a Furvana recipe to preview the cart.</p></div>';if(total)total.textContent='$0.00';return}items.innerHTML=cart.map(function(i){sum+=i.price;return '<div class="fu-demo-cart__item"><img src="'+i.image+'" alt=""><div><strong>'+i.title+'</strong><small>Demo item</small></div><b>'+money(i.price)+'</b></div>'}).join('');if(total)total.textContent=money(sum)}
  function openCart(){if(drawer)drawer.hidden=false} function closeCart(){if(drawer)drawer.hidden=true}
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href="#"],a[href^="/collections"],a[href^="/pages"],a[href^="/blogs"]'); if(a&&!a.matches('[data-fu-add]')&&!a.matches('[data-fu-nav]')) e.preventDefault();
    var add=e.target.closest('[data-fu-add]');if(add){e.preventDefault();cart.push({title:add.dataset.title||'Furvana item',price:Number(add.dataset.price)||0,image:add.dataset.image||''});render();showToast('Added to demo cart');return}
    if(e.target.closest('[data-fu-cart-open]')){e.preventDefault();openCart();return} if(e.target.closest('[data-fu-cart-close]')){e.preventDefault();closeCart();return}
    if(e.target.closest('[data-fu-checkout]')){showToast(cart.length?'Demo checkout — no real order placed':'Your cart is empty');return}
    if(e.target.closest('[data-fu-search-open]')){e.preventDefault();document.querySelector('[data-fu-search]').hidden=false;return} if(e.target.closest('[data-fu-search-close]')){document.querySelector('[data-fu-search]').hidden=true;return}
    if(e.target.closest('[data-fu-menu-toggle]')){e.preventDefault();return}
    var nav=e.target.closest('[data-fu-nav]');if(nav){e.preventDefault();var t=document.querySelector(nav.getAttribute('href'));if(t)t.scrollIntoView({behavior:'smooth',block:'start'});var p=document.querySelector('[data-fu-menu-panel]');if(p)p.hidden=true;return}
    var menuPanel=document.querySelector('[data-fu-menu-panel]');if(menuPanel&&!menuPanel.hidden&&!e.target.closest('.fu-demo-menu-only'))menuPanel.hidden=true;
    var pill=e.target.closest('.product-card__pills .pill');if(pill){pill.parentNode.querySelectorAll('.pill').forEach(function(x){x.classList.remove('is-selected')});pill.classList.add('is-selected');return}
  });
  document.querySelectorAll('.product-card').forEach(function(card){var cta=card.querySelector('.product-card__cta');if(cta){cta.setAttribute('data-fu-add','');cta.dataset.title=card.querySelector('.product-card__title')?.textContent.trim()||'Furvana item';cta.dataset.price=(card.querySelector('.price:not(.price--compare)')?.textContent||'$0').replace(/[^0-9.]/g,'');cta.dataset.image=card.querySelector('img')?.src||'';cta.href='#'}});
  document.querySelectorAll('[data-fu-cart-open]').forEach(function(el){el.addEventListener('click',function(e){e.preventDefault()})});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeCart();var s=document.querySelector('[data-fu-search]');if(s)s.hidden=true;var p=document.querySelector('[data-fu-menu-panel]');if(p)p.hidden=true}});render();
});
